/* unplugin-vue-components disabled */import script from "./ExchangeActionSheet.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExchangeActionSheet.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__